/** One immutable-per-tick view of merged input state. */
export interface InputSnapshot {
  /** Normalized movement, magnitude ≤ 1 (analog-preserving from stick). */
  moveX: number;
  moveY: number;
  /** Edge-triggered (true only on the tick the button went down). */
  interactPressed: boolean;
  confirmPressed: boolean;
  cancelPressed: boolean;
  pausePressed: boolean;
  /** Level-up reroll (R / Ⓧ). */
  rerollPressed: boolean;
  /** Level-up skip (T / LB). */
  skipPressed: boolean;
  /** Pocket consumable (Q / Ⓨ). */
  pocketPressed: boolean;
  /** Run overview panel (Tab, I / pad Back). */
  overviewPressed: boolean;
  /** Character active ability (F, Space / pad RB). */
  activePressed: boolean;
  /** Held state (for channels like the summoning circle). */
  interactHeld: boolean;
  /** Active button held (Cask's fuse channel). */
  activeHeld: boolean;
  /** Menu navigation: edge-triggered with initial-delay-then-repeat. */
  navX: -1 | 0 | 1;
  navY: -1 | 0 | 1;
  /** Last-used device, drives UI glyph hints ("Press Ⓐ" vs "Press E"). */
  device: 'kb' | 'pad';
}

export function emptySnapshot(): InputSnapshot {
  return {
    moveX: 0, moveY: 0,
    interactPressed: false, confirmPressed: false,
    cancelPressed: false, pausePressed: false,
    rerollPressed: false, skipPressed: false, pocketPressed: false,
    overviewPressed: false, activePressed: false,
    interactHeld: false, activeHeld: false,
    navX: 0, navY: 0,
    device: 'kb',
  };
}
